export default __webpack_public_path__ + "static/media/Title Sponsor.906b12f3.png";